// extracted by mini-css-extract-plugin
module.exports = {"eventInfoCard":"EventInfo_eventInfoCard__3IcXu","eventInfoSummary":"EventInfo_eventInfoSummary__1xTVE"};